export var sliderBaseOptions = {
  min: 0,
  step: 0.01
};